<ng-container *transloco="let t" class="container">
  <div class="{{cssClass ? cssClass : ''}}">
    @if ((label || translatedLabel) && labelIsVisible) {
      <label class="trim-text" for="{{formId ? formId : formControlName}}">{{ translatedLabel ?? t(label!) }}
        @if (control.errors?.['required']) {
          <small>*</small>
        }
      </label>
    }
    @if (type === 'text') {
      <input type="{{type}}" id="{{formId ? formId : formControlName}}" class="form-control"
             autocomplete="{{autocomplete ? autocomplete : 'on'}}" name="{{formControlName}}" [formControl]="control"
             [placeholder]="translatedPlaceholder ? translatedPlaceholder : placeholder ? t(placeholder) : t(label!)"
             [readonly]="readonly"/>
    }
    @if (type === 'password') {
      <input type="{{type}}" id="{{formId ? formId : formControlName}}" class="form-control" name="{{formControlName}}"
             [formControl]="control"
             [placeholder]="translatedPlaceholder ? translatedPlaceholder : placeholder ? t(placeholder) : t(label!)"
             [readonly]="readonly"/>
    }
    @if (type === 'number') {
      <input type="{{type}}" id="{{formId ? formId : formControlName}}" class="form-control"
             autocomplete="{{autocomplete ? autocomplete : 'on'}}" name="{{formControlName}}" [formControl]="control"
             [placeholder]="translatedPlaceholder ? translatedPlaceholder: placeholder ? t(placeholder) : t(label!)"
             [min]="min" [max]="max" [readonly]="readonly"/>
    }
    @if (type === 'decimal') {
      <input type="text" name="{{formControlName}}" [formControl]="control" id="{{formId ? formId : formControlName}}"
             class="form-control"
             [placeholder]="translatedPlaceholder ? translatedPlaceholder : placeholder ? t(placeholder) : t(label!)"
             numberFormatter [readonly]="readonly"/>
    }
    @if (control.touched && !hideErrorMessage) {
      @for (errorMessage of control.errors | errorMessages:formControlName;track errorMessage) {
        <div class="errorMes pt-1">
          {{ errorMessage }}
        </div>
      }
    }
  </div>
</ng-container>
